import Inspector from './inspector';
const { InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const {
    background,
    margin,
    backgroundImg,
    hasMobileImage,
    fullHeight,
    backgroundImgMobile,
  } = attributes;

  const staticDefaultBackground = 'https://via.placeholder.com/400x245';

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section className={`MiddleBanner ${margin} ${background}`}>
        <picture
          className={`
            MiddleBanner-image-background
            ${!hasMobileImage ? 'MiddleBanner-image-background-desk' : ''}
            ${fullHeight ? 'MiddleBanner-image-background-full-height' : ''}
          `}
        >
          <source
            media="(min-width:768px)"
            srcset={backgroundImg.src || staticDefaultBackground}
            alt={backgroundImg.alt}
          />
          <img src={backgroundImgMobile.src} alt={backgroundImgMobile.alt} />
        </picture>

        <div className="Container">
          <div className="MiddleBanner-content">
            <InnerBlocks
              template={[
                [
                  'base/image-sumicity',
                  {
                    margin: 'margin-small',
                  },
                ],
                [
                  'base/heading-sumicity',
                  {
                    containerized: false,
                    titleTag: 'h2',
                    variant: 'title-5',
                    color: 'color-white',
                  },
                ],
                [
                  'base/heading-sumicity',
                  {
                    containerized: false,
                    titleTag: 'p',
                    variant: 'subtitle',
                    color: 'color-white',
                    margin: 'margin-section-small',
                  },
                ],
                [
                  'base/button-sumicity',
                  {
                    variant: 'btn-orange',
                    margin: 'margin-none',
                  },
                ],
              ]}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Edit;
